module.exports = __webpack_public_path__ + "static/media/download.98151944.svg";